var map = {
	"./1/symbol_0.png": "8e53",
	"./1/symbol_1.png": "4172",
	"./1/symbol_10.png": "27ba",
	"./1/symbol_11.png": "b9ae",
	"./1/symbol_12.png": "576b",
	"./1/symbol_2.png": "7b28",
	"./1/symbol_3.png": "2c90",
	"./1/symbol_4.png": "65ab",
	"./1/symbol_5.png": "e822",
	"./1/symbol_6.png": "e09a",
	"./1/symbol_7.png": "c31c",
	"./1/symbol_8.png": "2650",
	"./1/symbol_9.png": "594a",
	"./2/symbol_0.png": "193b",
	"./2/symbol_1.png": "b9f0",
	"./2/symbol_10.png": "e5ee",
	"./2/symbol_11.png": "aa90",
	"./2/symbol_12.png": "25b1",
	"./2/symbol_2.png": "6d37",
	"./2/symbol_3.png": "d049",
	"./2/symbol_4.png": "0463",
	"./2/symbol_5.png": "cfae",
	"./2/symbol_6.png": "a0da",
	"./2/symbol_7.png": "8172",
	"./2/symbol_8.png": "7642",
	"./2/symbol_9.png": "8ed3",
	"./3/symbol_0.png": "c7fd",
	"./3/symbol_1.png": "f84c3",
	"./3/symbol_10.png": "f548",
	"./3/symbol_12.png": "0c81",
	"./3/symbol_2.png": "5195",
	"./3/symbol_3.png": "07f1",
	"./3/symbol_4.png": "455d",
	"./3/symbol_5.png": "2af2",
	"./3/symbol_6.png": "7872",
	"./3/symbol_7.png": "4f62",
	"./3/symbol_8.png": "acaa",
	"./3/symbol_9.png": "ddbb",
	"./4/symbol_0.png": "6226",
	"./4/symbol_1.png": "9ed1",
	"./4/symbol_10.png": "9908",
	"./4/symbol_12.png": "c2075",
	"./4/symbol_2.png": "1e05",
	"./4/symbol_3.png": "94c6",
	"./4/symbol_4.png": "73ea1",
	"./4/symbol_5.png": "98f0",
	"./4/symbol_6.png": "7785",
	"./4/symbol_7.png": "2fb1",
	"./4/symbol_8.png": "d99c",
	"./4/symbol_9.png": "341f",
	"./gold1.png": "98bc",
	"./gold2.png": "b378",
	"./gold3.png": "3e2f",
	"./gold4.png": "d770",
	"./silver1.png": "1b7a",
	"./silver2.png": "6dbe",
	"./silver3.png": "23f5",
	"./silver4.png": "d10f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3e35";